import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { getPointsPlans } from "redux/actions/purchase";

export interface IPointsPlan{
  amount: number
  tax:number
  id:number
}
export interface IPurchase {
  pointsPlanToPurchase: IPointsPlan | null
  pointsPlans:IPointsPlan[],
  loading: boolean
}

const initialState: IPurchase = {
    pointsPlanToPurchase: null,
    pointsPlans:[],
    loading: false
}

export const purchaseSlice = createSlice({
  name: "purchaseSlice",
  initialState,
  reducers: {
    setPointsPlaneToPurchase: ((state, action: PayloadAction<IPointsPlan | null>) => {
      state.pointsPlanToPurchase = action.payload
    }),
  },
  extraReducers: (builder) => {
      builder.addCase(getPointsPlans.rejected, (state) => {
        state.loading = false;
      })
      builder.addCase(getPointsPlans.fulfilled, (state, action) => {
        state.pointsPlans = action.payload
        state.loading = false;
      })
      builder.addCase(getPointsPlans.pending, (state) => {
        state.loading = true;
      })
    }
})

export const {setPointsPlaneToPurchase} = purchaseSlice.actions;
export default purchaseSlice.reducer;